import Axios from "axios";

// Create instance for JSON requests
export const axiosAPI = Axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}/api`,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    "Accept-Language": "en-GB,en",
  },
});

// Create instance for file uploads
export const axiosupload = Axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}/api`,
  headers: {
    "Content-Type": "multipart/form-data",
    Accept: "application/json",
    "Accept-Language": "en-GB,en",
  },
});

// Add interceptor to attach token dynamically
const attachToken = (config) => {
  const token = localStorage.getItem("SWA_token") || sessionStorage.getItem("SWA_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
};

axiosAPI.interceptors.request.use(attachToken, (error) => Promise.reject(error));
axiosupload.interceptors.request.use(attachToken, (error) => Promise.reject(error));
